export const tabs = [
  {
    key: 'sbn',
    label: 'Sở Ban Ngành',
    component: 'SoBanNganhCard', 
    columns: 5, // Thêm số cột cho tab này
    dataSource: () => import('../lichHop/data.js').then(m => m.Data.SoBanNganhData())
  },
  {
    key: 'xa',
    label: 'Xã / Phường',
    component: 'XaPhuongCard',
    columns: 6, // Thêm số cột cho tab này
    dataSource: () => import('../lichHop/data.js').then(m => m.Data.XaData())
  },
//   {
//     key: 'ubnd',
//     label: 'UBND',
//     dataSource: () => import('../lichHop/data.js').then(m => m.Data.UBNDData())
//   },

]